import { Component, OnInit } from '@angular/core';
import { AbilityInitializer, AuthService, InitService, User } from './scip/services';
import { map, switchMap, take } from 'rxjs/operators';
import { AvanoLoadingIndicatorService } from '@avano/avano-components';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  userWithoutRoles$: Observable<boolean>;

  isAuthenticated$: Observable<boolean>;

  appBlockingIdentifier = AvanoLoadingIndicatorService.LOADING_IDENTIFIER_APPLICATION;

  constructor(private authService: AuthService, private abilityService: AbilityInitializer, private initService: InitService) {}

  ngOnInit(): void {
    this.isAuthenticated$ = this.initService.initApplication().pipe(
      switchMap(() => this.authService.getUser$()),
      map((user: User) => !!user),
      take(1)
    );
    this.userWithoutRoles$ = this.abilityService.getMissingRoles();
  }
}
